import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {motion} from "framer-motion";
import adminLogo from "../../adminLogo.svg";
import "../../styles/admin/AdminAssistants.css"
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import { GlobalContext } from "../GlobalContext";

export default function AdminAssistants({active, setActive,mobileActive, setMobileActive}){
    const {admin, setAdmin} = useContext(GlobalContext);
    const [assistants,setAssistants] = useState(false);
    const [showAssistantToAdd, setShowAssistantToAdd] = useState(null);
    const [message, setMessage] = useState("error message");
    const [showMessage, setShowMessage] = useState(false);
    const [loadAssistants, setLoadAssistants] = useState(false);
    const [assistantToAdd, setAssistantToAdd] = useState({
        id:"",
        name:"",
        email:"",
        password:"",
        generatedCodes:0,
        usedCodes:0,

    })
    const [showOTPForm, setShowOTPForm] = useState(false);
    const [OTP, setOTP] = useState("");
    const [assistantsList , setAssistantsList] = useState([]);
    const [otpResent, setOtpResent] = useState(false);
    const navigate = useNavigate();

    const getAssistants = async()=>{
        let admin2 = null;
        let isNull = false;
        if(admin === null || admin === undefined){
            await axios.get(`${BASE_URL}/teacher/get-admin-by-token`,{withCredentials:true})
            .then((response)=>{
                setAdmin(response.data);
                admin2 = response.data;
            }).catch((error)=>{
                navigate("/")
                console.log(error);
                isNull = true;
                return;
            })
        }
        else{
            admin2 = {...admin};
        }
        if(isNull) return;
        await axios.get(`${BASE_URL}/teacher/assistants?adminId=${admin2.id}`,{withCredentials: true})
        .then((response)=>{
            setAssistantsList(response.data);
            setAssistants(true);
        }).catch((error)=>{
            console.log(error);
            navigate("/");
        })
    }

    function addAssistanst(){
        axios.post(`${BASE_URL}/teacher/add-assistant`,assistantToAdd,{withCredentials:true})
        .then((response)=>{
            setShowAssistantToAdd(false)
            setShowOTPForm(true);
        }).catch((error)=>{
            setMessage(error.response.data);
            setShowMessage(true);
            
        })
    }

    function sendOTP(){
        axios.post(`${BASE_URL}/teacher/assistant-otp`,{"otp":OTP,"adminId":admin.id},{withCredentials:true})
        .then((response)=>{
            setShowOTPForm(false);
            setMessage("تم اضافة المساعد بنجاح");
            setShowMessage(true);
            setLoadAssistants(!loadAssistants);
            setAssistantToAdd({
                    id:"",
                    name:"",
                    email:"",
                    password:"",
                    generatedCodes:0,
                    usedCodes:0,

                })
                setOTP("");
        }).catch((error)=>{
            setMessage("خطأ OTP رمز");
            setShowMessage(true);
        })
    }

    function resendOTP(){
        axios.get(`${BASE_URL}/auth/resendOTP?email=${assistantToAdd.email}`,{withCredentials:true})
        .then((response)=>{
          setOtpResent(true);
        }).catch((error)=>{
          setMessage(error.response.data);
          setShowMessage(true);
        })
      }

    function checkAdding(){
        axios.get(`${BASE_URL}/teacher/check-add-assistant`,{withCredentials:true})
        .then((response)=>{
            setShowAssistantToAdd(true);
        }).catch((error)=>{
            if(error.response.status === 406){
                setMessage("لقد وصلت الي الحد الاقصي من المساعدين الرجاء الترقية للحصول علي المزيد من المساعدين");
                setShowMessage(true);
            }
            else{
                console.log(error);
            }
        })
    }
    useEffect(()=>{
        getAssistants();
        setActive("المساعدين")
        setMobileActive("assistants mobile");
    },[loadAssistants])
    return(

        <div>
         {assistants && (
                <div>
                    
                    <h3>المساعدين</h3>
                    <div className="assistants-div">
                        <button className="add-assistant" onClick={checkAdding}>اضافة مساعد</button>
                    {assistantsList.map((assistant,index)=>{
                        return (
                            <div
                                key={index}
                                className={`assistant-card-animation ${active=== "المساعدين"? "assistant-card-in" : "assistant-card-out"}`}
                                style={{ animationDelay: `${index * 0.2}s` }}
                            >
                            <div className='assistant-card' key={assistant.id} onClick={()=> {navigate(`/admin-home/admin-assistant-profile/${assistant.id}`);}}>
                                
                                <div className='assistant-info'>
                                    <p>المستحق: {assistant.currentFunds}</p>
                                    <p>{assistant.email}: البريد الإلكتروني</p>
                                    <h4>{assistant.name}</h4>
                                </div>
                                <img src={adminLogo} alt='no' className='assistant-photo'></img>
                            </div>
                            </div>

                        )
                    })}
                    </div>
                    </div>)}

            { showAssistantToAdd && (
                <div className="overlay">
                <div className="add-assistant-form">
                    <h3 className="add-assitant-form-h3">اضافة مساعد للمادة</h3>
                    <label>الاسم</label>
                    <input
                        type="text"
                        dir="rtl"
                        lang="ar"
                        value={assistantToAdd.name}
                        onChange={(e) => setAssistantToAdd({ ...assistantToAdd, name: e.target.value })}/>
                    <label>البريد الالكتروني</label>
                    <input
                        type="email"
                        value={assistantToAdd.email}
                        onChange={(e) => setAssistantToAdd({ ...assistantToAdd, email: e.target.value })}/>                   
                    <label>كلمة المرور</label>
                    <input
                        type="password"
                        value={assistantToAdd.password}
                        onChange={(e) => setAssistantToAdd({ ...assistantToAdd, password: e.target.value })}/>
                    <div className="add-assistant-form-buttons-div">
                        <button  onClick={() => {setShowAssistantToAdd(false);
                        setAssistantToAdd({
                                id:"",
                                name:"",
                                email:"",
                                password:"",
                                generatedCodes:0,
                                usedCodes:0,

                            })}}>الغاء</button>
                        <button  onClick={addAssistanst}>اضافة</button>
                    </div>
                </div>
                </div>

            )}

            { showOTPForm && (
                <div className="overlay">
                <div className="otp-form">
                    <h3>ادخل الرمز الذي تم ارساله الي {assistantToAdd.email}</h3>
                    <input
                        type="text"
                        value={OTP}
                        onChange={(e) => setOTP(e.target.value)}
                        placeholder="ادخل الرمز"/>
                    <button onClick={sendOTP} >ارسال</button>
                    
                </div>
                </div>
                 )}


            { showOTPForm && (
                <div className="overlay">
                <div className="otp-form">
                    <h3>ادخل الرمز الذي تم ارساله الي {assistantToAdd.email}</h3>
                    <div style={{display:"flex",
                      justifyContent:"center",
                    }}>
                    <p style={{
                      fontSize:"small",
                      margin:"0px",
                      textAlign:"center",
                      paddingTop:"4%",
                      paddingRight:"10px",
                      textDecorationLine:"underline",
                      cursor:"pointer"
                    }} onClick={resendOTP}>إعادة إرسال الرمز</p>
                    <input
                        type="text"
                        value={OTP}
                        onChange={(e) => {
                          setOTP(e.target.value)}}
                        placeholder="ادخل الرمز"/>
                    <button onClick={sendOTP} >ارسال</button>
                    </div>
                    {otpResent&&(
                      <p>تم إعادة ارسال الرمز</p>
                    )}
                </div>
                </div>
                 )}

                { showMessage && (
                    <div className="overlay">
                        <div className="home-owner-message">
                            <p>{message}</p>
                            <button onClick={() => setShowMessage(false)}>اغلاق</button>
                        </div>
                    </div>
                )}
        </div>

    )
}